var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',_vm._b({ref:"table",attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"id"},on:{"action":_vm.action},scopedSlots:_vm._u([{key:"end",fn:function(){return [_vm._t("default")]},proxy:true},{key:"item-preview",fn:function(ref){
var item = ref.item;
return [_c('schedule-tag',{attrs:{"tag":item}})]}}],null,true)},'base-table',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }